var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Log\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.47,4.64 L16.97,4.64 L16.97,6.14 L15.47,6.14 L15.47,4.64 Z M15.47,9.26 L16.97,9.26 L16.97,10.76 L15.47,10.76 L15.47,9.26 Z M15.47,13.88 L16.97,13.88 L16.97,15.38 L15.47,15.38 L15.47,13.88 Z M0,0 L0,20 L20,20 L20,0 L0,0 Z M1.5,4.93 L6.37,9.93 L6.37,15.54 L1.5,10.54 L1.5,4.93 Z M7.87,1.5 L12.54,1.5 L12.54,18.5 L7.87,18.5 L7.87,1.5 Z M6.37,1.5 L6.37,7.81 L1.5,2.81 L1.5,1.5 L6.37,1.5 Z M1.5,12.7 L6.37,17.7 L6.37,18.46 L1.5,18.46 L1.5,12.7 Z M18.5,18.5 L14,18.5 L14,1.5 L18.5,1.5 L18.5,18.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.31b44617a827704dc941fa50a7d03fd5.svg";
export { ForwardRef as ReactComponent };